import { v4 as randomUUID } from "uuid";
import type { HighnoteEnvironment } from "@highnoteplatform/types";

import { version } from "../package.json";

const { CARD_VIEWER_IFRAME_PORT = 3003 } = process.env;

const packageVersion: string = version ?? "";

export const iframeOrigin =
  process.env.NODE_ENV === "production"
    ? "https://cdn.highnote.com"
    : `http://localhost:${CARD_VIEWER_IFRAME_PORT}`;

const iframePath = (apiEnvironment: HighnoteEnvironment) => {
  let path = "";
  if (process.env.NODE_ENV === "production") {
    path = `card-viewer/${packageVersion}/`;
  }

  return apiEnvironment === "test"
    ? `${path}index_test.html`
    : `${path}index.html`;
};

export const generateUuid = () => randomUUID();

export const iframeUri = (apiEnvironment: HighnoteEnvironment) =>
  `${iframeOrigin}/${iframePath(apiEnvironment)}`;
